/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S10_P1Inputs */

const tr_iade_iptal_s10_p1 = /** @type {(inputs: Iade_Iptal_S10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri talepleri kvkk@emonse.com adresine iletilir. Önceden kabul edilmiş bir sözleşme aşağıdaki biçimlerde dışa aktarma hakkı tanıyorsa bu hak saklıdır:`)
};

const en_iade_iptal_s10_p1 = /** @type {(inputs: Iade_Iptal_S10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send data requests to kvkk@emonse.com. If a previously accepted contract grants export rights in the following formats, those rights remain valid:`)
};

const de_iade_iptal_s10_p1 = /** @type {(inputs: Iade_Iptal_S10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenanfragen richten Sie an kvkk@emonse.com. Gewährt eine bereits angenommene Vertragsfassung einen Export in den folgenden Formaten, bleibt dieser Anspruch bestehen:`)
};

const ru_iade_iptal_s10_p1 = /** @type {(inputs: Iade_Iptal_S10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросы данных направляются на kvkk@emonse.com. Если ранее принятый договор предоставляет экспорт в следующих форматах, это право сохраняется:`)
};

/**
* | output |
* | --- |
* | "Send data requests to kvkk@emonse.com. If a previously accepted contract grants export rights in the following formats, those rights remain valid:" |
*
* @param {Iade_Iptal_S10_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s10_p1 = /** @type {((inputs?: Iade_Iptal_S10_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S10_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s10_p1(inputs)
	if (locale === "de") return de_iade_iptal_s10_p1(inputs)
	if (locale === "ru") return ru_iade_iptal_s10_p1(inputs)
	return tr_iade_iptal_s10_p1(inputs)
});